export default {
  label: '中文菜单',
  labelEn: '英文菜单',
  icon: '图标',
  router: '路由',
  sort: '排序',
  rule: '权限标识',
  catalog: '目录',
  menu: '菜单',
  button: '按钮',
  parentMenu: '上级菜单',
  addChildMenu: '新增下级',
  helpIcon: '点击问号可跳转查询icon，查询完将icon name值传入输入框中',
  changeState: '切换状态',
  changeStateMsg: '是否将{{name}}改为【{{state}}】状态？',
};
